import React, { useState } from "react";
import { Box, Button, Flex, FormControl, FormLabel, Icon, Input, Text } from "@chakra-ui/react";
import { FaFileExport, FaPlay } from "react-icons/fa";
import { BLUEMONEDDBUTTONS, WHITE } from "../../../constants/colors";
import FavoritesList from "./components/favoritesList";
import { useNavigate } from "react-router-dom";
import { goToAddFavorites } from "../../../routes/coordinator";

export default function RegisterFavorites(){
    const navigate = useNavigate();

    return (
        <Flex direction={"column"} alignItems={"center"} bgColor={"#255255255"} h="100%">
            <Box width={"100%"} height={"fit-content"} mt={"0.3%"} mx="auto" py={3} px={3}>
                <Flex px={8} py={3} alignItems="center">
                    <FaPlay color={BLUEMONEDDBUTTONS} size="25px"/>
                    <Text mx={4} color={BLUEMONEDDBUTTONS} fontSize={35} fontWeight={"bold"}>Cadastro de Favoritos</Text>
                </Flex>
            </Box>
            <Box mb={"20px"} width={"100%"} height={"fit-content"} mt={"0.3%"} mx="auto" py={3} px={"90px"}>
                <Text color={BLUEMONEDDBUTTONS} fontWeight="bold">Atenção! As contas para TED já estão pré salvas.</Text>
            </Box>
            <Flex mb={"20px"} width={"90%"} mt={"0.3%"} >
                <Button
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                    onClick={() => {
                        goToAddFavorites(navigate);
                    }}
                >
                    NOVO CADASTRO
                </Button>
            </Flex>
            <FavoritesList/>
        </Flex>
    )
};